import { jsx as i } from "react/jsx-runtime";
import s from "@mui/material/Typography";
import "@mui/material";
const c = (r, t) => {
  if (!t)
    return;
  switch (r + t) {
    case "headingxxl":
      return "h1";
    case "headingxl":
      return "h2";
    case "headinglg":
      return "h3";
    case "headingmd":
      return "h4";
    case "headingsm":
      return "h5";
    case "headingxs":
      return "h6";
    case "textxl":
      return "subtitle1";
    case "textlg":
      return "subtitle2";
    case "textmd":
      return "body1";
    case "textsm":
      return "body2";
    case "textxs":
      return "caption";
    default:
      return;
  }
}, p = ({ children: r, variant: t, canWrap: e = !0, size: n = "md", ...o }) => {
  const a = c(t, n);
  return /* @__PURE__ */ i(
    s,
    {
      ...o,
      noWrap: !e,
      ...!!a && { variant: a },
      children: r
    }
  );
};
export {
  p as T
};
